<h2>Submit request</h2>
<mat-form-field class="mat-paginator-page-size-select">
  <mat-label></mat-label>
  <textarea matInput [(ngModel)]="modalBody" rows="10"></textarea>
</mat-form-field>
<div fxLayout="row" fxLayoutAlign="end center">
  <button mat-button color="primary" id="feedbackCancel" (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="primary" id="feedbackSubmit" (click)="dialogRef.close(modalBody)"
    [disabled]="!modalBody.length">Submit</button>
</div>